import { adminRoute } from "@/config/roles";
import mapLabelToComponent from "@/portals/(shared)/helpers/mapLabelToComponent";
import type { RouteOption } from "@/components/Navigation/Toolbar/Views/DesktopToolbar";

export const DEFAULT_ROUTE_SECTION_OPTIONS: RouteOption[] = [
  {
    icon: "NavMenu__practices-icon",
    label: "Practices",
    mobileIcon: "practices.svg",
    route: adminRoute + "/practice",
  },
  {
    icon: "NavMenu__screening-icon",
    label: "Screening",
    mobileIcon: "screening.svg",
    route: adminRoute + "/a5_screenings",
  },
  {
    icon: "NavMenu__reports-icon",
    label: "Reports",
    mobileIcon: "reports.svg",
    route: adminRoute + "/reports",
  },
  {
    icon: "NavMenu__settings-icon",
    label: "Settings",
    mobileIcon: "settings.svg",
    route: adminRoute + "/settings",
  },
];

export const CUSTOMER_SUCCESS_MANAGER: RouteOption[] = [
  {
    activeIconComponent: mapLabelToComponent("Patients", true),
    icon: "NavMenu__patients-icon",
    iconComponent: mapLabelToComponent("Patients"),
    label: "Patients",
    mobileIcon: "patients.svg",
    route: adminRoute + "/patient",
  },
  {
    iconComponent: mapLabelToComponent("Search", false),
    label: "Search",
    route: adminRoute + "/search",
  },
];

export const ADMIN_OR_CSE_ROUTE_SECTION_OPTIONS: RouteOption[] = [
  {
    activeIconComponent: mapLabelToComponent("Practices", true),
    icon: "NavMenu__practices-icon",
    iconComponent: mapLabelToComponent("Practices", false),
    label: "Practices",
    mobileIcon: "practices.svg",
    route: adminRoute + "/practice",
  },
  {
    activeIconComponent: mapLabelToComponent("Screening", true),
    icon: "NavMenu__screening-icon",
    iconComponent: mapLabelToComponent("Screening", false),
    label: "Screening",
    mobileIcon: "screening.svg",
    route: adminRoute + "/a5_screenings",
  },
  {
    activeIconComponent: mapLabelToComponent("Customer Success", true),
    icon: "NavMenu__patients-icon",
    iconComponent: mapLabelToComponent("Customer Success", false),
    label: "Customer Success",
    mobileIcon: "customer_success.svg",
    route: adminRoute + "/customer-success",
  },
  {
    icon: "NavMenu__settings-icon",
    label: "Add New Practice",
    mobileIcon: "add_new.svg",
    mobileOnly: true,
    route: adminRoute + "/practice/add",
  },
  {
    activeIconComponent: mapLabelToComponent("Reports", true),
    icon: "NavMenu__reports-icon",
    iconComponent: mapLabelToComponent("Reports", false),
    label: "Reports",
    mobileIcon: "reports.svg",
    route: adminRoute + "/reports",
  },
  {
    activeIconComponent: mapLabelToComponent("Eligibility", true),
    icon: "NavMenu__eligibility-icon",
    iconComponent: mapLabelToComponent("Eligibility", false),
    label: "Eligibility",
    mobileIcon: "eligibility-icon-navy.svg",
    route: adminRoute + "/eligibility",
  },
  {
    iconComponent: mapLabelToComponent("Search", false),
    label: "Search",
    route: adminRoute + "/search",
  },
];

export const BILLING_PARTNER_ROUTE_SECTION_OPTIONS: RouteOption[] = [
  {
    icon: "NavMenu__reports-icon",
    label: "Reports",
    mobileIcon: "reports.svg",
    route: adminRoute + "/reports",
  },
  {
    icon: "NavMenu__settings-icon",
    label: "Settings",
    mobileIcon: "settings.svg",
    route: adminRoute + "/settings",
  },
  {
    iconComponent: mapLabelToComponent("Search", false),
    label: "Search",
    route: adminRoute + "/search",
  },
];

export const CO_SIGN_NAV_ITEM: RouteOption = {
  activeIconComponent: mapLabelToComponent("Co-Sign", true),
  icon: "NavMenu__cosign-icon",
  iconComponent: mapLabelToComponent("Co-Sign", false),
  label: "Co-Sign",
  route: adminRoute + "/cosignature",
};
